/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnVideo.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class EnVideo extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="EnVideo-view">
        <Helmet>
          <title>Video - CheckPlus</title>
        </Helmet>
        <Link to="/En">
          <div className="EnVideo-closeBtn" />
        </Link>

        <div className="EnVideo-container">
          <iframe
            className="EnVideo-iframe"
            title="Introducing CheckPlus"
            src="https://www.youtube.com/embed/gqgHB-2wutA"
            frameBorder="0"
            webkitallowfullscreen="webkitallowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            oallowfullscreen="oallowfullscreen"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  }
}

export default EnVideo;
